import {
  Box,
  Grid,
  Typography,
  IconButton,
  Modal,
  TextField,
  Button,
  MenuItem,
  Select,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { Delete } from '@mui/icons-material';
import Reels from './Reels';
import {
  deleteActor,
  deleteActorProfileImage,
  deleteActorSliderImage,
  getActorById,
  updateActorField,
  updateFirstName,
  updateLastName,
  updateUserImage,
  updateUserImages,
} from '../../api/axios';

const ViewProject = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [open, setOpen] = useState(false);
  const [render, setRender] = useState(false);
  const [editField, setEditField] = useState({ field: '', value: '' });

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await getActorById(id);
        setUser(response.user);
      } catch (error) {
        console.error('Error fetching the user data:', error);
      }
    };

    fetchUser();
  }, [id, render]);

  const handleEditClick = (
    api = 'actor',
    apiField,
    field,
    value,
    type = 'text',
    options = []
  ) => {
    setEditField({ api, apiField, field, value, type, options });
    // console.log('value: ', value);
    setOpen(true);
  };

  const handleSave = async () => {
    try {
      if (editField.field === 'imageURL') {
        const formData = new FormData();
        formData.append('imageURL', editField.value);

        const response = await updateUserImage(id, formData);

        const updatedImageURL = response.result?.updatedUser?.result?.imageURL;
        setUser((prevUser) => ({
          ...prevUser,
          result: {
            ...prevUser.result,
            imageURL: updatedImageURL,
          },
        }));
      } else if (editField.field === 'images') {
        const formData = new FormData();
        if (editField.value instanceof FileList) {
          for (let i = 0; i < editField.value.length; i++) {
            formData.append('images', editField.value[i]);
          }
        } else if (editField.value instanceof File) {
          formData.append('images', editField.value);
        }

        const response = await updateUserImages(id, formData);

        const updatedImages = response.result?.updatedUser?.images || [];
        setUser((prevUser) => ({
          ...prevUser,
          result: {
            ...prevUser.result,
            images: updatedImages,
          },
        }));
      } else if (editField.field === 'fullName') {
        const [firstName, lastName] = editField.value.split(' ');
        await updateFirstName(id, firstName);
        await updateLastName(id, lastName);
        setUser((prevUser) => ({
          ...prevUser,
          registerResult: {
            ...prevUser.registerResult,
            firstName,
            lastName,
          },
        }));
      } else {
        await updateActorField(
          editField.api,
          editField.field,
          id,
          { [editField.apiField]: editField.value }
        );
        if (editField.api === 'actor') {
          setUser((prevUser) => ({
            ...prevUser,
            result: {
              ...prevUser.result,
              [editField.apiField]: editField.value,
            },
          }));
        } else {
          setUser((prevUser) => ({
            ...prevUser,
            registerResult: {
              ...prevUser.registerResult,
              [editField.apiField]: editField.value,
            },
          }));
        }
      }
      setRender(!render);
      setOpen(false);
    } catch (error) {
      console.error('Error updating the user data:', error);
    }
  };
  if (!user) {
    return <Typography>Loading...</Typography>;
  }

  const DeleteUserActor = async (userId) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `Are you sure want to delete this Actor`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, continue',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      try {
        await deleteActor(userId);
        setRender(!render);
        Swal.fire('Success', 'User status updated successfully', 'success');
      } catch (error) {
        Swal.fire(
          'Error',
          'There was an error updating the user status',
          'error'
        );
      }
    } else {
      Swal.fire('Canceled', 'The action has been canceled.', 'info');
    }
  };

  const getSliderImages = () => {
    const images = registerResult?.images;
    if (Array.isArray(images)) return images;
    if (typeof images === 'string') {
      try {
        const parsed = JSON.parse(images);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return images ? [images] : [];
      }
    }
    return [];
  };

  const handleDeleteSliderImage = async (imageUrl) => {
    const confirmed = await Swal.fire({
      title: 'Remove this photo?',
      text: 'It will be removed from the actor profile immediately.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Remove',
    });
    if (!confirmed.isConfirmed) return;

    try {
      await deleteActorSliderImage(id, imageUrl);
      setUser((current) => ({
        ...current,
        registerResult: {
          ...current.registerResult,
          images: getSliderImages().filter((image) => image !== imageUrl),
        },
      }));
      Swal.fire('Removed', 'The photo was removed from the profile.', 'success');
    } catch (error) {
      Swal.fire('Error', error.response?.data?.message || 'Unable to remove photo.', 'error');
    }
  };

  const handleDeleteProfileImage = async () => {
    const confirmed = await Swal.fire({
      title: 'Remove this profile photo?',
      text: 'It will be removed from the actor profile immediately.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Remove',
    });
    if (!confirmed.isConfirmed) return;

    try {
      await deleteActorProfileImage(id);
      setUser((current) => ({
        ...current,
        result: { ...current.result, imageURL: null },
      }));
      Swal.fire('Removed', 'The profile photo was removed.', 'success');
    } catch (error) {
      Swal.fire('Error', error.response?.data?.message || 'Unable to remove profile photo.', 'error');
    }
  };

  const { result, registerResult } = user;

  return (
    <Box
      color={'#6e0506'}
      m='20px'
      height='80vh'
      overflow='auto'
      paddingRight='20px'
    >
      <Header title={`VIEW USER ID ${id}`} subtitle='View User Details' />

      <Grid container spacing={2} pl={2} sx={{ fontSize: '1.0rem' }}>
        {/* Image */}
        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            Image
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          {result?.imageURL ? (
            <>
              <img
                src={result?.imageURL}
                alt={`${registerResult?.firstName} ${registerResult?.lastName}`}
                style={{ width: '150px', height: 'auto', borderRadius: '50%' }}
              />
              <IconButton
                size='small'
                aria-label='Remove profile photo'
                onClick={handleDeleteProfileImage}
                sx={{ color: '#6e0506', backgroundColor: 'white' }}
              >
                <Delete fontSize='small' />
              </IconButton>
            </>
          ) : (
            <Typography fontSize='1.0rem'>No image available</Typography>
          )}
          <IconButton
            sx={{ color: '#6e0506', mt: '-100px', ml: '0px' }}
            onClick={() =>
              handleEditClick(
                'actor',
                'updateUserImage',
                `imageURL`,
                `${result?.imageURL || ''}`,
                'image'
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>
        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            Silder Images
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          {(() => {
            try {
              const imagesArray = getSliderImages();

              if (imagesArray.length > 0) {
                return imagesArray
                  .map((image, index) => (
                    <Box key={image} sx={{ position: 'relative' }}>
                      <img
                        src={image}
                        alt={`${registerResult?.firstName} ${registerResult?.lastName}`}
                        style={{ width: '100px', height: '100px', objectFit: 'cover', margin: '5px' }}
                      />
                      <IconButton
                        size='small'
                        aria-label='Remove photo'
                        onClick={() => handleDeleteSliderImage(image)}
                        sx={{ position: 'absolute', top: 0, right: 0, color: '#6e0506', backgroundColor: 'white' }}
                      >
                        <Delete fontSize='small' />
                      </IconButton>
                    </Box>
                  ));
              }
              return (
                <Typography fontSize='1.0rem'>No images available</Typography>
              );
            } catch (error) {
              console.error('Error parsing images:', error);
              return (
                <Typography fontSize='1.0rem'>
                  Error displaying images
                </Typography>
              );
            }
          })()}
          <IconButton
            sx={{ color: '#6e0506', mt: '-100px', ml: '0px' }}
            onClick={() =>
              handleEditClick(
                'user',
                'updateUserImages',
                'images',
                '',
                'image',
                [],
                true
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>
        {/* Reels */}

        <Reels userDetails={registerResult} moderator />

        {/* Full Name */}
        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            Full Name
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>{`${registerResult?.firstName} ${registerResult?.lastName}`}</Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'user',
                'fullName',
                'fullName',
                `${registerResult?.firstName} ${registerResult?.lastName}`
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>
        {/* Email */}
        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            Email
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>{registerResult?.email}</Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'user',
                'email',
                'updateEmail',
                `${registerResult?.email}`
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            User Role
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>{registerResult?.role}</Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'user',
                'role',
                'updateRole',
                `${registerResult?.role}`,
                'dropdown',
                ['director', 'actor', 'crew']
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* Contact Number */}
        <Grid item xs={2}>
          <Typography variant='h6' fontSize='1.0rem'>
            Contact Number
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {registerResult?.contactNumber}
          </Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'user',
                'contactNumber',
                'updateContactNo',
                `${registerResult?.contactNumber}`
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* Birthday */}
        <Grid item xs={2}>
          <Typography fontSize='1.0rem' variant='h6'>
            Birthday
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>{registerResult?.birthday}</Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'user',
                'birthday',
                'updateBirthDay',
                `${registerResult?.birthday}`,
                'date'
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* Ethnicity */}
        <Grid item xs={2}>
          <Typography fontSize='1.0rem' variant='h6'>
            Ethnicity
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {registerResult?.ethnicity || 'Not provided'}
          </Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'user',
                'ethnicity',
                'updateEthnicity',
                `${registerResult?.ethnicity}`,
                'dropdown',
                [
                  'African American',
                  'Asian',
                  'Latino Hispanic',
                  'European American',
                  'Middle Eastern',
                  'Native American',
                  'Pacific Islander',
                  'Indian South Asian',
                  'Other',
                ]
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* Age */}
        <Grid item xs={2}>
          <Typography fontSize='1.0rem' variant='h6'>
            Age
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {registerResult?.age || 'Not provided'}
          </Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'user',
                'age',
                'updateAge',
                `${registerResult?.age}`
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* Location */}
        <Grid item xs={2}>
          <Typography fontSize='1.0rem' variant='h6'>
            Location
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography>{result?.location || 'Not provided'}</Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'actor',
                'location',
                'updateLocation',
                `${result?.location}`
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* Eye Color */}
        <Grid item xs={2}>
          <Typography fontSize='1.0rem' variant='h6'>
            Eye Color
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {result?.eyeColor || 'Not provided'}
          </Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'actor',
                'eyeColor',
                'updateEyeColor',
                `${result?.eyeColor}`,
                'dropdown',
                ['Black', 'Brown', 'Blue', 'Green', 'Gray']
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* Hair Color */}
        <Grid item xs={2}>
          <Typography fontSize='1.0rem' variant='h6'>
            Hair Color
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {result?.hairColor || 'Not provided'}
          </Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'actor',
                'hairColor',
                'updateHairColor',
                `${result?.hairColor}`,
                'dropdown',
                ['Black', 'Brown', 'Red', 'Yellow', 'Gray']
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* Weight */}
        <Grid item xs={2}>
          <Typography fontSize='1.0rem' variant='h6'>
            Weight
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {result?.weight || 'Not provided'}
          </Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'actor',
                'weight',
                'updateWeight',
                `${result?.weight}`
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* Height */}
        <Grid item xs={2}>
          <Typography variant='h6'>Height</Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {result?.height || 'Not provided'}
          </Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'actor',
                'height',
                'updateHeight',
                `${result?.height}`
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* Facebook Link */}
        <Grid item xs={2}>
          <Typography fontSize='1.0rem' variant='h6'>
            Facebook Link
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {result?.fbLink || 'Not provided'}
          </Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'actor',
                'fbLink',
                'updateFbLink',
                `${result?.fbLink}`
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* Instagram Link */}
        <Grid item xs={2}>
          <Typography fontSize='1.0rem' variant='h6'>
            Instagram Link
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {result?.instagramLink || 'Not provided'}
          </Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'actor',
                'instagramLink',
                'updateInstagram',
                `${result?.instagramLink}`
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* TikTok Link */}
        <Grid item xs={2}>
          <Typography fontSize='1.0rem' variant='h6'>
            TikTok Link
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {result?.tikTokLink || 'Not provided'}
          </Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'actor',
                'tikTokLink',
                'updateTikTokLink',
                `${result?.tikTokLink}`
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* YouTube Link */}
        <Grid item xs={2}>
          <Typography fontSize='1.0rem' variant='h6'>
            YouTube Link
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {result?.youtubeLink || 'Not provided'}
          </Typography>
          <IconButton
            sx={{ color: '#6e0506', mt: '-10px', ml: '20px' }}
            onClick={() =>
              handleEditClick(
                'actor',
                'youtubeLink',
                'updateYoutubeLink',
                `${result?.youtubeLink}`
              )
            }
          >
            <EditIcon />
          </IconButton>
        </Grid>

        {/* Created At */}
        <Grid item xs={2}>
          <Typography fontSize='1.0rem' variant='h6'>
            Created At
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {new Date(result?.createdAt).toLocaleString()}
          </Typography>
          {/* <IconButton sx={{mt:'-10px',ml:'20px'}} onClick={() => handleEditClick('actor','fullName', `${registerResult?.crea}`,'date')}>
            <EditIcon />
          </IconButton> */}
        </Grid>

        {/* Updated At */}
        <Grid item xs={2}>
          <Typography fontSize='1.0rem' variant='h6'>
            Updated At
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {new Date(result?.updatedAt).toLocaleString()}
          </Typography>
          {/* <IconButton sx={{mt:'-10px',ml:'20px'}} onClick={() => handleEditClick('actor','fullName', `${registerResult.firstName} ${registerResult.lastName}`)}>
            <EditIcon />
          </IconButton> */}
        </Grid>
        {/* Admin Active */}
        <Grid item xs={2}>
          <Typography fontSize='1.0rem' variant='h6'>
            Admin Active
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {registerResult.adminActive ? 'Activated' : 'Deactivated'}
          </Typography>
          {/* <IconButton sx={{mt:'-10px',ml:'20px'}} onClick={() => handleEditClick('actor','fullName', `${registerResult.firstName} ${registerResult.lastName}`)}>
            <EditIcon />
          </IconButton> */}
        </Grid>

        {/* User Active */}
        <Grid item xs={2}>
          <Typography fontSize='1.0rem' variant='h6'>
            User Active
          </Typography>
        </Grid>
        <Grid
          item
          xs={10}
          sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}
        >
          <Typography fontSize='1.0rem'>
            {registerResult.userActive ? 'Activated' : 'Deactivated'}
          </Typography>
          {/* <IconButton sx={{mt:'-10px',ml:'20px'}} onClick={() => handleEditClick('actor','fullName', `${registerResult.firstName} ${registerResult.lastName}`)}>
            <EditIcon />
          </IconButton> */}
        </Grid>
        <Grid
          item
          xs={10}
          sx={{
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            borderRadius: '4px',
            mb: '50px',
          }}
        >
          <IconButton
            sx={{ color: '#6e0506', borderRadius: '4px' }}
            onClick={() => DeleteUserActor(id)}
          >
            <Delete />
            <Typography fontSize='1.0rem'>Delete Actor</Typography>
          </IconButton>
        </Grid>
      </Grid>

      <Modal
        sx={{ color: '#6e0506' }}
        open={open}
        onClose={() => setOpen(false)}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant='h6' mb={2}>
            Edit {editField.field}
          </Typography>
          {editField.type === 'text' && (
            <TextField
              fullWidth
              label={`Enter new ${editField.field}`}
              value={editField.value}
              onChange={(e) =>
                setEditField({ ...editField, value: e.target.value })
              }
            />
          )}
          {editField.type === 'date' && (
            <input
              style={{
                width: '100%',
                border: '1px solid #ccc',
                borderRadius: '4px',
                padding: '10px',
              }}
              type='date'
              value={editField.value}
              onChange={(e) =>
                setEditField({ ...editField, value: e.target.value })
              }
            />
          )}
          {editField.type === 'dropdown' && (
            <Select
              fullWidth
              value={editField.value}
              onChange={(e) =>
                setEditField({ ...editField, value: e.target.value })
              }
            >
              {editField.options.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          )}
          {editField.type === 'image' && (
            <input
              type='file'
              accept='image/*'
              multiple
              onChange={(e) =>
                setEditField({
                  ...editField,
                  value:
                    editField.field === 'images'
                      ? e.target.files
                      : e.target.files[0],
                })
              }
              style={{
                width: '100%',
                marginTop: '10px',
              }}
            />
          )}
          <Box mt={2} display='flex' justifyContent='flex-end'>
            <Button onClick={() => setOpen(false)} sx={{ mr: 2 }}>
              Cancel
            </Button>
            <Button
              variant='contained'
              sx={{
                bgcolor: '#6e0506',
                '&:hover': {
                  bgcolor: '#6e0506',
                },
              }}
              onClick={handleSave}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default ViewProject;
